import React from 'react';
import AppShell from '@/components/AppShell';
import SEO from '@/components/SEO';
import ViolationWizard from '@/components/ViolationWizard';

export default function ViolationWizardPage() {
  return (
    <AppShell title="Violation wizard">
      <SEO title="Violation Appeal Wizard | Poettik" description="Assess a TikTok Shop violation and draft a submit-ready appeal." noindex />
      <div data-testid="violation-wizard-page">
        <ViolationWizard mode="app" />
      </div>
    </AppShell>
  );
}
